/* ========== 対象処理 ========== */
// 1. SMS認証コード送信処理
// 2. 戻るボタン
// 3. IVR認証コード送信処理

document.addEventListener("DOMContentLoaded", function () {
  const getSmsAuthButton = document.getElementById('get_sms_code');
  const backButton = document.getElementById('back_button');
  const getIvrAuthButton = document.getElementById('get_ivr_code');

  if (getSmsAuthButton) {
    // SMS認証コード送信
    getSmsAuthButton.addEventListener("click", () => {
      getSmsAuthCode(getSmsAuthButton);
    });

    // IVR認証へのリンク表示
    displayIvrAuthLink();

    // IVR認証モーダルの表示
    const modal = document.querySelector('.wl-modal');
    const ivrModal = document.querySelector('#ivr-modal-button');
    const closeModelImg = document.querySelector('#close-modal-img');
    ivrModal.addEventListener('click', (e) => {
      // モーダルを開く
      modal.classList.add('display-modal');
    });

    modal.addEventListener('click', (e) => {
      // モーダル外側をクリックされた時
      if (!e.target.closest('#verification__prompt')) {
        closeIvrModal();
      }
    });
    closeModelImg.addEventListener('click', (e) => {
      closeIvrModal();
    });
  }

  if (backButton) {
    // 戻るボタン
    backButton.addEventListener("click", () => {
      setBackField();
    });
  }

  if (getIvrAuthButton) {
    // IVR認証コード送信
    getIvrAuthButton.addEventListener("click", () => {
      getSmsAuthCode(getIvrAuthButton, 0);
    });
  }
});

/* ========== 固定値開始 ========== */

const APP_PROXY_URL = `https://${location.hostname}/apps/proxy`;

// 会員ステータス
const ACTIVATE_STATUS = {
  PROVISIONAL_NEW: '0', // 仮会員
  PROVISIONAL_MIGRATION: '1', // 移行仮会員
  DEFINITIVE: '2' // 本会員
};

// 特殊会員ステータス
const SEND_MAIL_TYPE = {
  NORMAL: '0', // 仮会員
  VIP: '1', // 特殊会員
  MIGRATE: '2', // 移行会員
};

// 特殊会員ステータス
const VIP_STATUS = {
  NORMAL: '0', // 仮会員
  VIP: '1' // 特殊会員
};

// 性別
const SEX_TYPE = {
  OTHERS: '0', // 指定なし
  MEN: '1', // 男性
  WOMAN: '2' // 女性
};

// 関心のあるブランド
const BLANDLIST = [
  '',
  'ISSEY MIYAKE',
  'IM MEN',
  '132 5. ISSEY MIYAKE',
  'PLEATS PLEASE ISSEY MIYAKE',
  'HOMME PLISSÉ ISSEY MIYAKE',
  'A-POC ABLE ISSEY MIYAKE',
  'BAO BAO ISSEY MIYAKE',
  'me ISSEY MIYAKE',
  'HaaT',
  'GOOD GOODS ISSEY MIYAKE',
  'ISSEY MIYAKE PARFUMS',
  'ISSEY MIYAKE WATCH',
  'ISSEY MIYAKE EYES'
];

const PLUS_CATEGORY = [0, 3, 4, 6, 7];
const MINUS_CATEGORY = [1, 2, 5, 8];
const OPERATION_CATEGORY = [4, 5];

// オンラインストアID
const STORE_ID = 'PP200801';

// 注文状況ステータス
const ORDER_STATUS = {
  NORMAL: 1, // 通常
  CANCEL: 2, // キャンセル
  REFUND: 3 // 返品
};

// ポイントカテゴリ
const POINT_CATEGORY = [
  '獲得',
  '利用',
  '返品',
  'キャンセル',
  '加算',
  '減算',
  '移行',
  '入会',
  '失効'
];

/* ========== 固定値終了 ========== */

/* ========== 共通関数開始 ========== */

// IVR認証モーダルを閉じる
const closeIvrModal = () => {
  const displayModals = document.querySelectorAll('.display-modal');
  displayModals.forEach(function (displayModal) {
    displayModal.classList.remove('display-modal');
  });
}

// SMS認証コード取得
const getSmsAuthCode = async (getSmsAuthButton, smsFlg = '') => {
  const url = `${APP_PROXY_URL}/api/customer/sms_authenticate`;
  let errorMessage = document.querySelector('.smsAuthCode');
  let successMessage = document.querySelector('.auth_code_success');
  let ivrSuccessMessage = document.querySelector('.ivr_auth_code_success');
  errorMessage.innerText = '';
  successMessage.innerHTML = '';
  ivrSuccessMessage.innerHTML = '';
  errorMessage.style.display = 'none';
  successMessage.style.display = 'none';
  ivrSuccessMessage.style.display = 'none';
  btnLoading(getSmsAuthButton);
  if (String(smsFlg) === '0') {
    // IVR認証
    successMessage = ivrSuccessMessage;
  }

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  const path = link.pathname;

  if (!token  && path.indexOf('phone_edit') == -1) {
    errorMessage.style.display = 'block';
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    btnStopLoading(getSmsAuthButton);
    return;
  }

  const params = validateSmsAuth(token, smsFlg);
  if (!params) {
    btnStopLoading(getSmsAuthButton);
    return;
  }

  const res = await fetchPostMethod(url, params);

  if(res.message == 'ok'){
    successMessage.innerHTML = '認証コードを送信しました';
    successMessage.style.display = 'block';
  }else{
    errorMessage.innerText = '認証コード送信に失敗しました';
    errorMessage.style.display = 'block';
  }
  // IVR認証の電話番号をSMS認証に転記
  if (res.message == 'ok' && String(smsFlg) === '0') {
    let phoneNumber = document.querySelector('input[name=phoneNumber]');
    let smartPhoneNumber = document.querySelector('input[name=smartPhoneNumber]');
    phoneNumber.value = smartPhoneNumber.value;
  }
  btnStopLoading(getSmsAuthButton);
};

// 会員情報取得
const getCustomer = async () => {
  const res = await fetchGetMethod(`${APP_PROXY_URL}/api/customer`);

  // if (!res || res.message != "ok") {
  //   if(res.detailCode != 401005){
  //     alert('会員情報が取得できませんでした。\nログアウトします。');
  //     window.location.href = `https://${location.hostname}/account/logout`;
  //   }
  //   return null;
  // }

  return res.customer;
};

// 会員情報取得（本登録前）
const getPreCustomer = async (url) => {
  const res = await fetchGetMethod(url);

  if (!res || res.message != "ok") {
    return null;
  }

  return res.customer;
};

/**
 * shopify上の注文情報を取得する
 */
const getShopifyOrders = () => {
  const el = document.getElementById('json-customer-orders');
  return JSON.parse(el.textContent);
}

//会員情報表示画面
// 国/地域を設定する
const setCountry = (customer) => {
  return customer.country == 'JP' ? '日本' : 'その他';
};

// 生年月日を設定する
const setBirthday = (customer) => {
  return `${customer.birthYear}年 ${customer.birthMonth}月 ${customer.birthDay}日`;
};

// 性別を設定する
const setSex = (customer) => {
  let sex = '指定なし';

  if (customer.sex == SEX_TYPE.MEN) {
    sex = '男性';
  } else if (customer.sex == SEX_TYPE.WOMAN) {
    sex = '女性';
  }

  return sex;
};

/**
 * 全期間購入履歴取得
 *
 */
const getAllOrder = async () => {
  const url = new URL(`${APP_PROXY_URL}/api/customer/payments`);
  url.searchParams.set('history_type', 1);
  url.searchParams.set('display_method', 0);
  url.searchParams.set('year', '');

  // crm の orders
  const ret = await getPaymentHistories(url.href);

  if (!ret) {
    return;
  }

  const crmOrders = ret.purchaseHistories;

  // shopifyのorders
  const shopifyOrders = getShopifyOrders();

  // merge crm orders, shopify orders
  const orders = mergeCustomerOrders(crmOrders, shopifyOrders, 0);

  return orders;
};

/**
 * 購入履歴取得
 *
 * @param {string} url
 * @returns
 */
const getPaymentHistories = async (url) => {
  const res = await fetchGetMethod(url);
  return res && res.result
    ? res
    : null;
};

/**
 * crmの注文情報とshopifyの注文情報をマージして返す
 *
 * @param {Array} crmOrders
 * @param {Array} shopifyOrders
 * @param {number} dataFlg
 * @returns
 */
const mergeCustomerOrders = (crmOrders, shopifyOrders, dataFlg) => {
  return crmOrders.map(crmOrder => {
    const shopifyOrder = shopifyOrders.find(shopifyOrder => shopifyOrder.id == crmOrder.extRefPrchseId);
    return mergeOrder(crmOrder, shopifyOrder, dataFlg);
  });
}

/**
 * crmとshopifyのorder情報をmergeする
 *
 * @param {*} crmOrder
 * @param {*} shopifyOrder
 * @param {number} dataFlg
 * @returns
 */
const mergeOrder = (crmOrder, shopifyOrder, dataFlg) => {
  const order = getBaseOrder(crmOrder);

  // shopify以外の注文情報
  if (!shopifyOrder) {
    // 注文明細を税込にする
    order.purchaseDetails = order.purchaseDetails.map(detail => {
      if (Number(order.tax) !== 0) {
        // CRMからは税抜金額が渡ってくるので税込金額に変換
        detail.productPrice = convertIncludeToExclude(detail.productPrice);
      }

      return detail;
    });

    order.isLinked = order.purchaseDetails.length > 0;

    return order;
  }

  return assignShopifyOrder(order, shopifyOrder, dataFlg);
}

/**
 * 表示用のorder情報にshopifyの注文情報を反映する
 *
 * @param {*} order
 * @param {*} shopifyOrder
 * @param {number} dataFlg 0: マイページ用, 1: 購入履歴用
 * @returns
 */
const assignShopifyOrder = (order, shopifyOrder, dataFlg) => {
  order.isLinked = order.purchaseDetails.length > 0; // 売上連携済フラグ
  order.refunds = shopifyOrder.refunds;
  order.purchaseDetails = makePurchaseDetails(order, shopifyOrder);
  order.mpc = shopifyOrder.mpc;
  if (!dataFlg) {
    return order;
  }

  order.isGrantedPoint = order.newPoint > 0; // CRMポイント付与フラグ
  order.totalNetAmount = shopifyOrder.totalNetAmount;
  order.orderName = shopifyOrder.name;
  order.createdAt = shopifyOrder.createdAt;
  order.shippingFee =
    Number(shopifyOrder.totalPrice) + Number(shopifyOrder.usedPoint) >= 11000
    ? 0
    : shopifyOrder.shippingPrice;
  order.purchaseTotalAmt = setPurchaseTotalAmt(order, shopifyOrder);
  order.purchaseSubtotalAmt = setPurchaseSubtotalAmt(order);
  order.tax = setTax(order);
  order.fulfillmentStatus = shopifyOrder.fulfillmentStatus;
  order.paymentMethod = {
    gatewayDisplayName: shopifyOrder.paymentMethod.gatewayDisplayName,
    creditCardLastFourDigits: shopifyOrder.paymentMethod.creditCardLastFourDigits
  };
  order.shippingAddress = trimShippingAddress(shopifyOrder.shippingAddress);

  return order;
};

// 会員購入履歴用注文番号取得API（IM_DEV-666）
const FALLBACK_ORDER_NAME_CHUNK_SIZE = 20; // API仕様: order_ids は1〜20件
const FALLBACK_ORDER_NAME_TIMEOUT_MS = 10000; // タイムアウト10秒・リトライなし

/**
 * 突合失敗注文の注文番号フォールバック取得（IM_DEV-666）
 *
 * mergeCustomerOrders で Shopify 注文 JSON（最新50件）と突合できず、orderName が
 * 13桁注文IDのまま残った EC注文について、会員購入履歴用注文番号取得APIへ
 * 13桁IDを送り7桁注文番号を取得して orderName を上書きする。
 * 取得失敗・該当なしの場合は13桁IDのまま維持し、購入履歴の描画は継続する（デグレ防止）。
 * ※ 共通の mergeCustomerOrders は変更せず、購入履歴経路（setOrderHistory）からのみ呼び出す。
 *
 * @param {Array} orders 表示用マージ済みの注文配列（重複除去後）
 * @returns {Promise<Array>} orders（同一参照を返す）
 */
const applyOrderNameFallback = async (orders) => {
  if (!Array.isArray(orders) || orders.length === 0) {
    return orders;
  }

  // 突合失敗のEC注文（orderName が13桁注文IDのまま）を抽出
  // 突合成功時は assignShopifyOrder で orderName が7桁注文番号に上書き済みのため
  // orderName === extRefPrchseId なら突合失敗と判別できる
  const unresolved = orders.filter(order =>
    isShopifyOrder(order.storeId) && order.orderName === order.extRefPrchseId
  );
  if (unresolved.length === 0) {
    return orders;
  }

  // 重複を除いた13桁注文IDの一覧 → 20件以下のチャンクに分割（API仕様の上限）
  const orderIds = [...new Set(unresolved.map(order => order.extRefPrchseId))];
  const chunks = [];
  for (let i = 0; i < orderIds.length; i += FALLBACK_ORDER_NAME_CHUNK_SIZE) {
    chunks.push(orderIds.slice(i, i + FALLBACK_ORDER_NAME_CHUNK_SIZE));
  }

  const orderNameMap = new Map();
  let errorStatus = null;

  await Promise.all(chunks.map(async (orderIdsChunk) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FALLBACK_ORDER_NAME_TIMEOUT_MS);
    try {
      // logged_in_customer_id は AppProxy がサーバ側で自動注入するため付与不要
      const res = await fetch(`${APP_PROXY_URL}/api/customer/order_names`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_ids: orderIdsChunk }),
        credentials: 'include',
        signal: controller.signal
      });
      if (!res || !res.ok) {
        // 401/422/500 等。13桁IDのまま維持
        errorStatus = res ? res.status : 'no-response';
        return;
      }
      const json = await res.json();
      const results = json && Array.isArray(json.results) ? json.results : [];
      results.forEach(({ order_id, order_name }) => {
        // 該当なしは空文字。空でない時だけ採用（13桁ID維持＝デグレ防止）
        if (order_name) {
          orderNameMap.set(String(order_id), order_name);
        }
      });
    } catch (e) {
      // タイムアウト/通信失敗。13桁IDのまま維持し描画は継続。リトライしない
      errorStatus = e && e.name === 'AbortError' ? 'timeout' : ((e && e.message) || 'error');
    } finally {
      clearTimeout(timer);
    }
  }));

  // 取得できた注文番号で orderName を上書き
  // 書式整形は不要（STG確認: ストアの order.name は # 等なしの生7桁で API と同書式）
  let resolvedCount = 0;
  unresolved.forEach(order => {
    const orderName = orderNameMap.get(String(order.extRefPrchseId));
    if (orderName) {
      order.orderName = orderName;
      resolvedCount += 1;
    }
  });

  // 調査用ログ（最小限）
  console.log(
    `[order-name-fallback] target:${unresolved.length} resolved:${resolvedCount}` +
    (errorStatus ? ` error:${errorStatus}` : '')
  );

  return orders;
};

/**
 * 注文明細（purchaseDetails）を作成する
 *
 * @param {*} order
 * @param {*} shopifyOrder
 * @returns
 */
const makePurchaseDetails = (order, shopifyOrder) => {
  // 売上連携済
  if (order.purchaseDetails.length > 0) {
    return order.purchaseDetails.map(detail => {
      // CRMからは税抜金額が渡ってくるので税込金額に変換
      detail.productPrice = convertIncludeToExclude(detail.productPrice);

      const shopifyLineitem = shopifyOrder.purchaseDetails.find(lineItem => {
        return lineItem.productCode === detail.productCode;
      });
      // Shopifyの情報で上書き
      if (shopifyLineitem) {
        detail.productUrl = shopifyLineitem.productUrl;
        detail.productName = shopifyLineitem.productName;
        detail.productSize = fetchSizeFromOptions(shopifyLineitem.optionsWithValues);
        detail.productColor = fetchColorFromOptions(shopifyLineitem.optionsWithValues);
      }

      detail.tags = shopifyLineitem ? shopifyLineitem.tags : '';

      return detail;
    });
  }

  const detailCopy = shopifyOrder.purchaseDetails.map(detail => ({...detail}));

  // 売上連携未連携
  return detailCopy.map(detail => {
    detail.productSize = fetchSizeFromOptions(detail.optionsWithValues);
    detail.productColor = fetchColorFromOptions(detail.optionsWithValues);

    // 一部キャンセル or 一部返品以外はスキップ
    if (isCancelOrder(order.isStatus) || !shopifyOrder.refunds) {
      return detail;
    }

    // 一部キャンセル・一部返品の情報を注文明細に反映する
    detail = setRefundsInfo(detail, shopifyOrder.refunds);

    return detail;
  });
}

/**
 * 消費税（tax）の値を計算する
 *
 * @param {*} order
 * @returns
 */
const setTax = (order) => {
  // shopify以外の注文
  if (!isShopifyOrder(order.storeId)) {
    return order.tax;
  }

  // 消費税はCRMの値は見ない
  return new Decimal(order.purchaseTotalAmt).plus(order.usedPoint).minus(order.purchaseSubtotalAmt).minus(order.shippingFee).toNumber();
}

/**
 * 税込合計（purchaseTotalAmt）を計算する
 *
 * @param {*} order
 * @param {*} shopifyOrder
 * @returns
 */
const setPurchaseTotalAmt = (order, shopifyOrder) => {
  // shopify以外での注文
  if (!isShopifyOrder(order.storeId)) {
    return order.purchaseTotalAmt;
  }

  // キャンセル or 返品注文
  if (isCancelOrder(order.isStatus)) {
    return shopifyOrder.totalPrice;
  }

  // 売上連携済
  if (order.isLinked) {
    return order.purchaseTotalAmt;
  }

  // 購入商品代金 - ポイント利用額を算出する
  const purchaseTotalAmt = order.purchaseDetails.reduce((pre, v) => {
    const taxIncludeSubtotal = new Decimal(v.productPrice).times(v.productQty).toNumber();
    return pre.plus(taxIncludeSubtotal);
  }, new Decimal(0));

  return purchaseTotalAmt.minus(order.usedPoint).plus(order.shippingFee).toNumber();
}

/**
 * 税抜合計（purchaseSubtotalAmt）を計算する
 *
 * @param {*} order
 * @returns
 */
const setPurchaseSubtotalAmt = (order) => {
  // shopify以外での注文
  if (!isShopifyOrder(order.storeId)) {
    return order.purchaseSubtotalAmt;
  }

  return calcPurchaseSubtotalAmt(order);
}

/**
 * shippingAddressの整備
 *
 * @param {*} shopifyOrder
 * @returns
 */
const trimShippingAddress = (shippingAddress) => {
  return {
    lastName: shippingAddress.firstName.split(' ')[0],
    firstName: shippingAddress.firstName.split(' ')[1],
    fullName: shippingAddress.fullName,
    zip: shippingAddress.zip,
    province: shippingAddress.province,
    city: shippingAddress.city,
    phone: shippingAddress.phone,
    address1: shippingAddress.address1,
    address2: shippingAddress.address2
  };
};

/**
 * options_with_valuesからサイズを抽出する
 *
 * @param {*} optionsWithValues
 * @returns
 */
const fetchSizeFromOptions = (optionsWithValues) => {
  const size = optionsWithValues?.find(
    ov => ov.name === 'サイズ'
  );

  return size ? size.value : 'ー';
}

/**
 * options_with_valuesからサイズを抽出する
 *
 * @param {*} optionsWithValues
 * @returns
 */
const fetchColorFromOptions = (optionsWithValues) => {
  const color = optionsWithValues?.find(
    ov => ov.name === '色' || ov.name === 'カラー'
  );

  return color ? color.value : 'ー';
}

/**
 * orderの基本形を作成する
 *
 * @param {*} crmOrder
 * @returns
 */
const getBaseOrder = (crmOrder) => {
  return {
    "orderName": crmOrder.extRefPrchseId,
    "newPoint": crmOrder.newPoint,
    "waitingPoint": crmOrder.waitingPoint,
    "extRefPrchseId": crmOrder.extRefPrchseId,
    "receiptNumber": crmOrder.extRefPrchseId,
    "usedPoint": crmOrder.usedPoint,
    "storeId": crmOrder.storeId,
    "storeName": crmOrder.storeName,
    "tax": crmOrder.tax,
    "shippingFee": 0,
    "purchaseDate": crmOrder.purchaseDate,
    "purchaseSubtotalAmt": crmOrder.purchaseSubtotalAmt,
    "purchaseTotalAmt": crmOrder.purchaseTotalAmt,
    "createdAt": crmOrder.purchaseDate,
    "isStatus": crmOrder.isStatus,
    "purchaseDetails": crmOrder.purchaseDetails,
    "fulfillmentStatus": null,
    "paymentMethod": null,
    "shippingAddress": null
  };
};

// ポイント概要表示
const setPointOverview = async (data) => {
  const availablePoints = data.pointBalance ? Number(data.pointBalance) : 0;
  document.getElementById('availablePoints').innerText = availablePoints.toLocaleString() + ' ポイント';
  
  // DOM要素を一度取得
  const expirationDateElement = document.querySelector('._expirationDate');
  const expirationWarning = document.querySelector('._expirationWarning');
  
  // 利用可能ポイントが0を超えた場合、有効期限を表示
  if (availablePoints > 0) {
    if (expirationDateElement) {
      const expirationDate = formatDate(data.pointExpiredAt);
      expirationDateElement.innerText = `有効期限 ${expirationDate}`;
    }
    
    // 有効期限が迫っているかチェック（30日以内）
    if (expirationWarning) {
      if (data.pointExpiredAt) {
        const expirationDateObj = new Date(data.pointExpiredAt);
        const today = new Date();
        const diffTime = expirationDateObj - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 0 && diffDays <= 30) {
          expirationWarning.style.display = 'block';
        } else {
          expirationWarning.style.display = 'none';
        }
      } else {
        expirationWarning.style.display = 'none';
      }
    }
  } else {
    if (expirationWarning) {
      expirationWarning.style.display = 'none';
    }
  }

  const waitingPoints = data.validWaitingPoint ? Number(data.validWaitingPoint) : 0;
  const waitingPointsByUnfulfilled = await getWaitingPointByUnfulfilledOrder();
  const totalWaitingPoints = waitingPoints + waitingPointsByUnfulfilled;
  const totalPoints = availablePoints + totalWaitingPoints;
  document.getElementById('waitingPoints').innerText = totalWaitingPoints.toLocaleString() + ' ポイント';
  document.getElementById('totalPoints').innerText = totalPoints.toLocaleString() + ' ポイント';
};

/**
 * 未発送商品の獲得予定ポイントを取得する
 */
const getWaitingPointByUnfulfilledOrder = async () => {
  const orders = await getAllOrder();
  let point = 0;
  const startDate = new Date('2023/03/22 00:00:00');

  for (let i = 0; i < orders.length; i++) {

    if ( orders[i].newPoint === 0 && orders[i].waitingPoint === 0) {

      // shopify外の注文
      // キャンセル or 返品注文
      // 売上連携済の場
      if (!isShopifyOrder(orders[i].storeId) || isCancelOrder(orders[i].isStatus) || orders[i].isLinked) {
        continue;
      }

      let orderDate = new Date(orders[i].purchaseDate);
      // 注文日が2023/03/22以降
      if (orderDate < startDate) {
        continue;
      }

      point += calcGetPoint(orders[i]);
      
    }
  }

  return point;
};

/**
 * 一部キャンセル・一部返品の情報を注文明細に反映する
 *
 * @param {*} detail
 * @param {*} refunds
 * @returns
 */
const setRefundsInfo = (detail, refunds) => {
  for (let i = 0; i < refunds.length; i++) {
    let items = refunds[i].refundLineItems;

    for (let j = 0; j < items.length; j++) {
      if (detail.lineItemId != items[j].lineItemId) {
        continue;
      }

      detail.productQty = detail.productQty - items[j].quantity;
    }
  }

  return detail;
};

/**
 * 獲得予定ポイントを計算する
 *
 * @param {*} order
 * @returns
 */
const calcGetPoint = (order) => {
  // 1. ポイント付与対象税込金額を算出する
  const total = new Decimal(calcPointTotalAmt(order));

  if (total.toNumber() == 0) {
    return 0;
  }

  // 2. ポイント付与対象税込金額から利用ポイントをマイナスする
  const usedPoint = Number(order.usedPoint);
  const totalAfterDiscount = total.minus(usedPoint);

  // 3.対象ポイント割合を計算する(5で端数処理する)
  const grantTargetRate = totalAfterDiscount.div(total);

  // ポイント付与率
  const grantPointRate = new Decimal(window.pointRate).div(100);

  // 4. 各商品の対象ポイント数にポイント付与率をかけてポイント付与数を算出する
  let getPoint = order.purchaseDetails.reduce((pre, v) => {
    if (!isTargetItem(v.tags)) {
      // ポイント対象外
      return pre;
    }

    // 商品の対象ポイント金額  = 上代 * 対象ポイント割合(5で端数処理する)
    const taxRate = v.taxRate ? new Decimal(v.taxRate).plus(1) : new Decimal(1.1);
    let unitPrice = new Decimal(v.productPrice).div(taxRate);
    let taxExcludeSubtotal = unitPrice.times(v.productQty);
    const targetItemAmount = taxExcludeSubtotal.times(grantTargetRate);

    // 商品のポイント付与数 = (商品の対象ポイント金額 * ポイント付与率)
    const itemGrantPoint = targetItemAmount.times(grantPointRate);

    return pre.plus(itemGrantPoint);
  }, new Decimal(0));

  // 5. ポイントキャンペーンの倍率をかける(端数切り捨て)
  const mpc = order.mpc ?? 1;
  getPoint = getPoint.times(mpc).toDP(0, Decimal.ROUND_DOWN);

  return getPoint.toNumber();
}

/**
 * ポイント対象額合計を計算する
 *
 * @param {*} order
 * @returns
 */
const calcPointTotalAmt = (order) => {
  const pointTotal = order.purchaseDetails.reduce((pre, v) => {
    if (!isTargetItem(v.tags)) {
      // ポイント対象外
      return pre;
    }

    const taxIncludeSubtotal = new Decimal(v.productPrice).times(v.productQty).toNumber();
    return pre.plus(taxIncludeSubtotal);
  }, new Decimal(0));

  return pointTotal.toNumber();
}

/**
 * 税抜合計（purchaseSubtotalAmt）を計算する
 *
 * @param {*} order
 * @returns
 */
const calcPurchaseSubtotalAmt = (order) => {
  const purchaseSubtotalAmt = order.purchaseDetails.reduce((pre, v) => {
    // 税率
    const taxRate = v.taxRate ? new Decimal(v.taxRate).plus(1) : new Decimal(1.1);
    // 上代
    const unitPrice = new Decimal(v.productPrice).div(taxRate);
    // lineitem税抜金額
    const taxExcludeSubtotal = unitPrice.times(v.productQty);

    return pre.plus(taxExcludeSubtotal);
  }, new Decimal(0));

  return purchaseSubtotalAmt.toDP(0, Decimal.ROUND_UP).toNumber();
}

/**
 * 税抜金額を税込金額に変換する
 *
 * @param {*} price
 * @returns
 */
const convertIncludeToExclude = (price) => {
  const priceSet = price ?? 0;
  return new Decimal(priceSet).times(1.1).toNumber();
}

/**
 * ポイント付与対象アイテムかどうか
 *
 * @param {string} tags
 * @returns
 */
const isTargetItem = (tags) => {
  if (!tags || tags == '') {
    return true;
  }

  const arr = tags.split(',');
  //return arr.includes('優待') || !arr.includes('sale');
  return !arr.includes('sale');
}

// DM可否を設定する
const setShopDM = (customer) => {
  return customer.shopDM == '1' ? '可' : '不可';
};

// ニュースレターを設定する
const setNewsletter = (customer, newsletterField) => {
  newsletterField.innerText = '';

  let newsletter = document.createElement('div');
  newsletter.innerText = customer.itemMailMagazine == '1' || customer.ecMailMagazine == '1' || customer.shopMailMagazine == '1' ? '可' : '不可';
  newsletterField.appendChild(newsletter);

  if (customer.itemMailMagazine == '1') {
    let itemMailMagazine = document.createElement('div');
    itemMailMagazine.innerText = '商品・ブランド・ギャラリー';
    newsletterField.appendChild(itemMailMagazine);
  }

  if (customer.ecMailMagazine == '1') {
    let ecMailMagazine = document.createElement('div');
    ecMailMagazine.innerText = 'オンラインストア';
    newsletterField.appendChild(ecMailMagazine);
  }

  if (customer.shopMailMagazine == '1') {
    let shopMailMagazine = document.createElement('div');
    shopMailMagazine.innerText = '店舗';
    newsletterField.appendChild(shopMailMagazine);
  }
};

// 関心あるブランドを設定する
const setBlandList = (customer, blandListField) => {
  blandListField.children[0].innerText = '';

  if (customer.brandinterestlist === null) {
    return;
  }

  for (let i = 0; i < customer.brandinterestlist.length; i++) {
    if (customer.brandinterestlist[i] == 0) {
      continue;
    }

    let blanditem = document.createElement('li');
    blanditem.innerText = BLANDLIST[customer.brandinterestlist[i]];
    blandListField.children[0].appendChild(blanditem);
  }
};

// 会員更新 / 会員移行画面
// 海外住所の設定をする
const setEditAddress = () => {
  let fpostcode = document.querySelectorAll('.f-postcode');
  let fprefectures = document.querySelectorAll('.f-prefectures');
  let fonlyJapan = document.querySelectorAll('.f-onlyJapan');

  for (let i = 0; i < fpostcode.length; i++) {
    fpostcode[i].classList.add('off');
  }
  for (let i = 0; i < fprefectures.length; i++) {
    fprefectures[i].classList.add('off');
  }
  for (let i = 0; i < fonlyJapan.length; i++) {
    fonlyJapan[i].classList.add('off');
  }
};

// 性別を設定する
const setEditSex = (sex) => {
  let sexEl = document.querySelectorAll('._sex input[name=sex]');

  // 性別
  for (let i = 0; i < sexEl.length; i++) {
    if (sexEl[i].value == sex) {
      sexEl[i].checked = true;
    } else {
      sexEl[i].checked = false;
    }
  }
};

// ニュースレターを設定する
const setEditNewsletter = (letterFlg) => {
  let getNews = document.querySelectorAll('._newsletter input[name=get_news]');

  for (let i = 0; i < getNews.length; i++) {
    if ((getNews[i].value == '1' && letterFlg) || (getNews[i].value == '0' && !letterFlg)) {
      getNews[i].checked = true;
    } else {
      getNews[i].checked = false;
    }
  }

  if (!letterFlg) {
    let letterArea = document.querySelector('.f-newsletter ._checkboxContainer');
    letterArea.classList.add('off');
  }
};

// DM可否を設定する
const setEditDM = (shopDMFlg) => {
  let shopDM = document.querySelectorAll('._dm input[name=shopDM]');

  for (let i = 0; i < shopDM.length; i++) {
    if (shopDM[i].value == shopDMFlg) {
      shopDM[i].checked = true;
    } else {
      shopDM[i].checked = false;
    }
  }
};

// 関心あるブランドを設定する
const setEditBlandList = (brandinterestlist) => {
  let brandlist = document.querySelectorAll('.f-interestBrands input[type=checkbox]');

  for (let bl = 0; bl < brandlist.length; bl++) {
    for (let cb = 0; cb < brandinterestlist.length; cb++) {
      if (bl == brandinterestlist[cb]) {
        brandlist[bl].checked = true;
      }
    }
  }
};

// マルチパスURL作成
const getMultipassUrl = (token) => {
  return `https://${location.hostname}/account/login/multipass/${token}`;
};

// 次の画面表示
const setNextField = () => {
  let steps = document.querySelector('._step').children;
  let openFields = document.querySelectorAll('.step-2-fields');
  let closeFields = document.querySelectorAll('.step-1-fields');

  for(i = 0; i < steps.length; i++){
    if (steps[i].classList.contains('_step2')) {
      steps[i].classList.add('on');
    } else {
      if(steps[i].classList.contains('_step3')){
        steps[i].classList.remove('on');
      }
    }
  }

  for(j = 0; j < openFields.length; j++){
    openFields[j].style.display = "block";
  }

  for(k = 0; k < closeFields.length; k++){
    closeFields[k].style.display = "none";
  }

  window.scrollTo({
    top: 0
  });
};

// 入力画面表示
const setBackField = (error = null) => {
  let steps = document.querySelector('._step').children;
  let openFields = document.querySelectorAll('.step-1-fields');
  let closeFields = document.querySelectorAll('.step-2-fields');
  let errorMessage = document.getElementById('error_message');

  errorMessage.style.display = "none";

  if(error){
    errorMessage.innerText = error;
    errorMessage.style.display = "block";
  }

  for(i = 0; i < steps.length; i++){
    if (steps[i].classList.contains('_step1')) {
      steps[i].classList.add('on');
    } else {
      steps[i].classList.remove('on');
    }
  }

  for(j = 0; j < openFields.length; j++){
    openFields[j].style.display = "block";
  }

  for(k = 0; k < closeFields.length; k++){
    closeFields[k].style.display = "none";
  }

  window.scrollTo({
    top: 0
  });
};

// 日付フォーマット
const formatDate = (date) => {
  let formattedDate = new Date(date);
  return formattedDate.getFullYear() + '年 ' + (formattedDate.getMonth() + 1) + '月 ' + formattedDate.getDate() + '日';
};

// 金額フォーマットに変換
const convertMoneyFormat = (price) => {
  return `${Number(price).toLocaleString()} 円`;
};

// エラーメッセージを非表示にする
const initErrorMessage = () => {
  let errorMessages = document.querySelectorAll('._error');
  for (let i = 0; i < errorMessages.length; i++) {
    let e = errorMessages[i];
    e.style.display = 'none';
    e.innerText = '';
  }
};

// エラーメッセージを表示する
const displayErrorMessage = (ele, message) => {
  let errorTag = document.querySelector(`.${ele.dataset.id}`);
  let oldMessagge = errorTag.textContent;
  errorTag.textContent = oldMessagge != '' ? oldMessagge : message;
  errorTag.style.display = 'block';
  return true;
};

/**
 * サーバーエラーメッセージを表示する
 *
 * @param {Array} errors
 * @param {Array} ignoreError
 */
const setServerValidationError = (errors, ignoreError = []) => {
  Object.keys(errors).forEach((key) => {
    if (ignoreError.includes(key)) {
      return;
    }

    let errorTag = key == 'country' ? document.querySelector('.select-country') : document.querySelector(`.${key}`);
    let oldMessagge = errorTag.textContent;
    errorTag.textContent = oldMessagge != '' ? oldMessagge : errors[key];
    errorTag.style.display = 'block';
  });
};

// urlパラメータにtokenがない場合は入力画面を非表示にする
const checkHasToken = (parent) => {
  for(i = 0; i < parent.childElementCount; i++){
    parent.children[i].style.display = 'none';
  }

  let errorMessage = document.createElement('p');
  errorMessage.className = '_customer error-message';
  errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
  parent.appendChild(errorMessage);
};

const fetchGetMethod = async (url) => {
  try {
    let res = await fetch(url, {
      method: 'GET',
      mode: "cors",
      headers: {
          'Content-Type': 'application/json',
          accept: "text/plain, */*",
      },
      credentials: 'include'
    });
    if (!res || res.status == 500) {
      return false;
    }
    let json = await res.json();
    return json;
  } catch (e) {
    console.log("[error]", e.message);
    return false;
  }
};

const fetchPostMethod = async (url, params) => {
  try {
    let res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    if (!res || res.status == 500) {
      return {
        error: "サーバーエラー"
      };
    }
    let json = await res.json();
    return json;
  } catch (e) {
    console.log("[error]", e.message);
    return {
      error: e.message
    };
  }
};

const fetchPutMethod = async (url, params) => {
  try {
    let res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    if (!res || res.status == 500) {
      return {
        error: "サーバーエラー"
      };
    }
    let json = await res.json();
    return json;
  } catch (e) {
    console.log("[error]", e.message);
    return {
      error: e.message
    };
  }
};

//ランダム値生成し、トークンに使用
const random = () => {
  const LENGTH = 8 //生成したい文字列の長さ
  const SOURCE = "abcdefghijklmnopqrstuvwxyz0123456789" //元になる文字
  let result = ''

  for(let i=0; i<LENGTH; i++){
    result += SOURCE[Math.floor(Math.random() * SOURCE.length)];
  }
  return result;
}


//認証番号入力イベント
const nextField = (code) => {
  if (code.value.length >= code.maxLength) {
    for (var i = 0, elm = code.parentNode.children; i < elm.length; i++) {
      if (elm[i] == code && i != elm.length - 1) {
          (elm[i + 1] || elm[0]).focus();
          break;
      }
    }
  }
}

//認証番号値確認イベント
const checkField = (code) => {
  if (!code.value.match(/[0-9]+/g)) {
    code.value = '';
  }
}

//ボタンローディング処理
const btnLoading = (submit_btn) => {
  submit_btn.setAttribute('aria-disabled', true);
  submit_btn.classList.add('loading');
  submit_btn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
}

//ボタンローディング解除処理
const btnStopLoading = (submit_btn) => {
  submit_btn.setAttribute('aria-disabled', false);
  submit_btn.classList.remove('loading');
  submit_btn.querySelector('.loading-overlay__spinner').classList.add('hidden');
}

//大文字変換
const changeZenkaku = (value) => {
  return value.replace(/[A-Za-z0-9]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });
}

// 表示年の選択肢作成
const setYear  = (year) => {
  let selectYear = document.querySelector('._select .prefectures');

  for(i = 0; i < 5; i++){
    let option = document.createElement('option');

    option.value = year;
    option.innerText = year;

    selectYear.appendChild(option);
    year--;
  }
};

//カナ表示管理
const changeLang = (furigana) => {
  //初期値
  document.addEventListener('wovnApiReady', function(){
    let firstLang = WOVN.io.getCurrentLang().code;
    if(firstLang == 'ja'){
      // furigana.style.display = 'flex';
    }else{
      furigana.style.display = 'none';
    }
  })

  //言語変更
  document.addEventListener('wovnLangChanged', function(){
    let lang = WOVN.io.getCurrentLang().code;
    if(lang == 'ja'){
      // furigana.style.display = 'flex';
    }else{
      furigana.style.display = 'none';
    }
  })
}

// IVR認証へのリンク表示
const displayIvrAuthLink = () => {
  const ivrAuthLink = document.querySelector('#ivr_auth_link');
  ivrAuthLink.style.display = 'block';
}

/**
 * キャンセル or 返品注文かどうか
 *
 * @param {number} status
 * @returns
 */
const isCancelOrder = (status) => {
  return status !== ORDER_STATUS.NORMAL;
};

/**
 * shopify経由の注文かどうか
 *
 * @param {string} status
 * @returns
 */
const isShopifyOrder = (storeId) => {
  return storeId === STORE_ID;
};
